// Owner-supplied commercial; original MP4 remains the primary source.
export const SPLASH_COMMERCIAL = Object.freeze({
    mp4: 'https://customer-assets-39nsmqrw.emergentagent.net/job_pdf-driven-build-1/artifacts/6e39dff951841cfd_Meet%20Splash%20v1.mp4',
    webm: '/videos/meet-splash.webm',
    poster: '/videos/meet-splash-poster.webp',
    durationSeconds: 90,
});
